module.exports = __webpack_public_path__ + "img/table-sort-asc.49d6da2b.svg";